import React from "react";
import {
    getCurrencyCode,
    getOrderCreatedAt,
    getOrderTotalAmount,
    getProductsData,
    getRemainingReturnDays,
    getRemainingWithdrawalDays,
    isComplaintsDisabledForAllItems,
    isWithdrawalBlocked,
    isWithdrawalSelectionLocked,
} from "~/cores/appCore";
import ProductsFlexWrapper, { ProductFlexItemWrapper } from "~/components/productItem/ProductsFlexWrapper";
import { formatReadableDateAndTimeShort, toDate } from "rylak-common";
import { formatCurrency } from "~/utils";
import { ProductItemWrapperOnly } from "~/components/productItem/ProductItem";
import { COLORS } from "~/constants";
import styles from "./ItemsPageHeader.module.scss";
import { isNil } from "lodash";

// Shown instead of a formatted amount when the amount is missing — it says "unknown" without
// asserting a number the way a fallback of 0 would.
const MISSING_AMOUNT_PLACEHOLDER = "—";

function TitleAndContent({ title, content }) {
    return (
        <>
            <div className={styles["title-and-content-title"]}>{title}:</div>
            <div className={styles["title-and-content-content"]}>{content}</div>
        </>
    );
}

function GridWrapper({ children, style }) {
    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "auto auto",
                gap: "10px",
                // padding: "15px",
                // justifyItems: "center",
                alignItems: "center",
                gridAutoRows: "1fr",
                ...style,
                // marginBottom: "15px",

                // justifyContent: "space-between",
            }}
        >
            {children}
        </div>
    );
}

export default function ItemsPageHeader({ appProps }) {
    const { getLocaleText, orderId, withdrawal } = appProps;

    const totalContent = formatCurrency({
        amount: getOrderTotalAmount(appProps),
        currency: getCurrencyCode(appProps),
    });

    const remainingDays = withdrawal === true ? getRemainingWithdrawalDays(appProps) : getRemainingReturnDays(appProps);
    const periodLabelKey = withdrawal === true ? "return-period.withdrawal" : "return-period";
    // Once the withdrawal period has elapsed, show the expired state regardless of the (rounded) day count.
    const periodExpired = isWithdrawalBlocked(appProps);

    const complaintsDisabled = isComplaintsDisabledForAllItems(appProps);

    return (
        <div>
            <ProductsFlexWrapper productsComponents={getProductsData(appProps)?.map(() => null)}>
                <ProductFlexItemWrapper>
                    <ProductItemWrapperOnly
                        style={{
                            justifyContent: "flex-start",
                            marginBottom: "20px",
                            padding: "15px",
                        }}
                    >
                        <div className={styles["inner-container"]}>
                            <GridWrapper>
                                <TitleAndContent title={getLocaleText("order")} content={orderId} />
                                <TitleAndContent title={getLocaleText("total")} content={totalContent ?? MISSING_AMOUNT_PLACEHOLDER} />
                                {/*<div*/}
                                {/*    style={{*/}
                                {/*        color: COLORS.textGray,*/}
                                {/*        fontSize: "14px",*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*    Order:*/}
                                {/*</div>*/}
                                {/*<span style={{fontWeight: 550}}>{orderId}</span>*/}
                                {/*{!_.isNil(getOrderTotalAmount(appProps)) && (*/}
                                {/*    <div*/}
                                {/*        style={{*/}
                                {/*            color: COLORS.textGray,*/}
                                {/*            fontSize: "13px",*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        Total:*/}
                                {/*    </div>*/}
                                {/*)}*/}
                                {/*{formatCurrency({*/}
                                {/*    amount: getOrderTotalAmount(appProps),*/}
                                {/*    currency: getCurrencyCode(appProps),*/}
                                {/*})}*/}
                            </GridWrapper>
                            <GridWrapper style={{ marginLeft: "auto" }}>
                                <TitleAndContent
                                    title={getLocaleText("purchase-date")}
                                    content={formatReadableDateAndTimeShort({
                                        dateTime: toDate(getOrderCreatedAt(appProps)),
                                    })}
                                />
                                {!isNil(remainingDays) && (
                                    <>
                                        <TitleAndContent
                                            title={getLocaleText(periodLabelKey)}
                                            content={
                                                !periodExpired && remainingDays > -1 ? (
                                                    <span>
                                                        {remainingDays} {getLocaleText("days-remaining", null, { lowerCase: true })}
                                                    </span>
                                                ) : (
                                                    <span style={{ color: COLORS.errorRed }}>{getLocaleText("no-days-remaining")}</span>
                                                )
                                            }
                                        />
                                    </>
                                )}
                                {/*{getOrderCreatedAt(appProps) && (*/}
                                {/*    <div*/}
                                {/*        style={{*/}
                                {/*            color: COLORS.textGray,*/}
                                {/*            fontSize: "13px",*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        Purchase date:*/}
                                {/*    </div>*/}
                                {/*)}*/}
                                {/*{formatReadableDateAndTimeShort(*/}
                                {/*    toDate(getOrderCreatedAt(appProps)))}*/}
                                {/*{getRemainingReturnDays(appProps) && (*/}
                                {/*    <div*/}
                                {/*        style={{*/}
                                {/*            color: COLORS.textGray,*/}
                                {/*            fontSize: "13px",*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        Return period:*/}
                                {/*    </div>*/}
                                {/*)}*/}
                                {/*{getRemainingReturnDays(appProps)} days*/}
                                {/*remaining*/}
                            </GridWrapper>
                        </div>
                    </ProductItemWrapperOnly>
                </ProductFlexItemWrapper>
            </ProductsFlexWrapper>
            <div>
                {withdrawal === true
                    ? getLocaleText(isWithdrawalSelectionLocked(appProps) ? "return-items.header-body.withdrawal" : "return-items.header-body.withdrawal-selectable")
                    : complaintsDisabled
                      ? getLocaleText("return-items.header-body.complaints-disabled")
                      : getLocaleText("return-items.header-body")}
            </div>
        </div>
    );
}
